let prefix = '/api/sap/payments';

function getReport() {
    return window.axios.post(prefix + '/prebatchs', {
    })
}

function getReportInvoices(data){
    return window.axios.post(prefix + '/review/invoices', {
        batchId: data,
    })
}

function deleteInvoces(data) {
    return window.axios.delete(prefix + '/delete/invoices', {
        data: {
            invoicesID: data
        }
    });
}

function aprovedBatch(data){
    return window.axios.post(prefix + '/approved/batch', {
        batchId: data,
    })
    
}





export default {
    getReport,
    getReportInvoices,
    deleteInvoces,
    aprovedBatch,
}